var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-wrap"},[_c('v-avatar',{attrs:{"color":"white","size":"33"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }